<template>
  <vs-popup
    v-if="table"
    :title="'Table: ' + (table ? table.table.name : '')"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="edit-venue-table-popup"
  >
    <div class="mb-4 flex flex-col p-8" v-if="!table.booking">
      <p class="text-center mb-2">No bookings</p>
      <vs-button
        v-if="
          hasPermissionForActiveVenue(
            'vp.vp.booking.createbookings'
          )
        "
        class="mx-auto"
        @click="handleCreateBooking()"
        >Add new booking</vs-button
      >
      <div v-if="table.table.discardedBooking" class="flex flex-col">
        <p class="text-sm text-center mt-12">
          There is an ended booking on this table
        </p>
        <vs-button
          class="mx-auto mt-1"
          type="flat"
          color="primary"
          size="small"
          @click="viewEndedBooking()"
          >See ended booking</vs-button
        >
      </div>
    </div>
    <div
      v-if="note"
      class="p-4 rounded mb-0 text-yellow-900 text-sm mb-6"
      style="
        background-color: rgb(255, 212, 134) !important;
        color: rgb(139, 93, 10) !important;
      "
    >
      <b>Table note: </b> {{ note }}
    </div>
    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button color="primary" type="border" @click="handlePopupClose"
        >Ok</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import EditPolicies from "../components/policies/EditPolicies.vue";
import { POLICY_LEVEL } from "@/store/modules/marcom/data-model/policy-configurations/index.js";

export default {
  components: { EditPolicies },
  props: {
    setupId: {
      type: String,
    },
  },
  data() {
    return {
      POLICY_LEVEL,
      table: undefined,
      showThisPopup: false,
      createBookingCallback: null,
    };
  },
  computed: {
    note: {
      get() {
        return this.table.note;
      },
    },
  },
  methods: {
    show(table, handleAddBookingClick) {
      this.table = table;
      this.showThisPopup = true;
      this.handleAddBookingClick = handleAddBookingClick;
    },
    handlePopupClose() {
      this.clonedTable = undefined;
      this.showThisPopup = false;
    },
    handleCreateBooking() {
      if (this.handleAddBookingClick) {
        this.handleAddBookingClick(this.table.table);
        this.showThisPopup = false;
      }
    },
    viewEndedBooking() {
      this.$emit("viewEndedBooking", this.table.table.discardedBooking);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-venue-table-popup::v-deep .vs-popup {
  width: 600px;

  .vs-popup--content {
    overflow: hidden;

    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
